"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceholdersProvider = exports.usePlaceholdersContext = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
/**
 * @internal
 */
var PlaceholdersContext = react_1.createContext({
    state: {
        placeholders: {},
    },
    updateState: noop_1.default,
});
PlaceholdersContext.displayName = "PlaceholdersContext";
/**
 * @internal
 */
exports.usePlaceholdersContext = function () { return react_1.useContext(PlaceholdersContext); };
/**
 * Wraps component into a PlaceholdersContext consumer enabling the children of this to access the current
 * placeholders state.
 *
 * @public
 */
function PlaceholdersProvider(props) {
    var _a;
    var children = props.children, initialValues = props.initialValues;
    var initialPlaceholdersState = (_a = initialValues === null || initialValues === void 0 ? void 0 : initialValues.reduce(function (acc, _a) {
        var _b = tslib_1.__read(_a, 2), placeholder = _b[0], value = _b[1];
        acc[placeholder.id] = tslib_1.__assign(tslib_1.__assign({}, placeholder), { value: value });
        return acc;
    }, {})) !== null && _a !== void 0 ? _a : {};
    var _b = tslib_1.__read(react_1.useState({
        placeholders: initialPlaceholdersState,
    }), 2), state = _b[0], updateState = _b[1];
    react_1.useDebugValue(state);
    return (react_1.default.createElement(PlaceholdersContext.Provider, { value: {
            state: state,
            updateState: updateState,
        } }, children));
}
exports.PlaceholdersProvider = PlaceholdersProvider;
//# sourceMappingURL=context.js.map